import { render } from "./TheConsumersCreation.vue?vue&type=template&id=48e6a871"
import script from "./TheConsumersCreation.vue?vue&type=script&lang=js"
export * from "./TheConsumersCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__